<template>
  <div class="col-sm-12 list-container nopads pt-2">
    <div class="data-list-item add" @click.stop="$emit('add')">
      <div class="item-img-cont add-title">
        <i class="fa fa-plus" />
      </div>
      <div class="item-text-cont">
        <span class="item-title-add">
          {{ $t('common.add_new') }}
        </span>
        <font-awesome-icon
          icon="clipboard"
          class="card-body-icon"
        />
      </div>
    </div>

      <div v-if="results.length > 0" class="list-content result-table my-3">
          <vue3-datatable
              ref="resultTable"
              :rows="results"
              :columns="fields"
              :pagination="false"
              :sticky-header="true"
              height="100%"
              :sortable="true"
              skin="bh-table-compact"
              row-class="routa-table-row"
              cell-class="routa-table-cell"
              @row-click="emitEdit"
          >
          </vue3-datatable>
      </div>
  </div>
</template>

<script>
import {workManagementHelper} from '../mixins/WorkManagementMixin'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'CostCentersList',
    mixins: [workManagementHelper],
    components: {Vue3Datatable},
    data() {
        return {
            fields: [
                {field: 'id', title: this.$t('common.id'), sort: true,  headerClass: 'routa-table-header', type: 'number'},
                {field: 'number', title: this.$t('common.number'), sort: true,  headerClass: 'routa-table-header', type: 'number'},
                {field: 'name', title: this.$t('common.name'), sort: true,  headerClass: 'routa-table-header'}
            ]
        }
    },
    props: {
        results: {
            type: Array,
            default: function () {
                return []
            }
        }
    },
    methods: {
        emitEdit(item) {
            this.$emit('edit', item)
        }
    }
}
</script>
